/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { filter, switchMap, withLatestFrom } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { State } from 'app/main/store';
import * as fromShared from 'app/user-auth/store/user-auth.selectors';
import { observableOf } from 'app/shared/rxjs/rxjs.utils';
import { AuthService } from 'app/user-auth/services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private store: Store<State>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.store.pipe(
      select(fromShared.getUserDetailsData),
      withLatestFrom(this.store.pipe(select(fromShared.getUserDetailsError))),
      filter(([userData, userError]) => !!userData || !!userError),
      switchMap(([userData, userError]) => {
        if (!!userError) {
          this.authService.unauthenticate();
          return observableOf(false);
        }
        return observableOf(true);
      })
    );
  }
}
